import { ENTITY_TYPES } from '@sales-center/common'
import { customValuesToFormModel } from '@user/components/CustomFields'
import { useGetSalesFunnelData } from '@user/components/Settings/SalesFunnels/hooks'
import { useSelectCustomFieldData } from '@user/store/customFields'
import { ISaveServicesForLaterFormModel } from '../FormContents/typings'

export function useInitialValues() {
  const { defaultFunnel } = useGetSalesFunnelData(ENTITY_TYPES.Opportunity)

  const { customFields } = useSelectCustomFieldData()

  const initialValues: ISaveServicesForLaterFormModel = {
    customFields: customValuesToFormModel(customFields),
    expectedClosingDate: new Date(),
    salesFunnelId: defaultFunnel?.id ?? '',
    serviceIds: [],
    shouldSyncNextActionDate: false,
  }

  return { initialValues } as const
}
